import { ENVIRONMENTS, PLATFORMS } from "./environment.common";

export const ENVS = {
    PLATFORM: PLATFORMS.WEB,
    ENVIRONMENT: ENVIRONMENTS.PROD,
};